import type { TeamValue } from '@atlassian/jira-issue-field-team/src/common/types.tsx';

const isProperShape = (value: object): value is { id: string; name: string } => {
	return Object.hasOwn(value, 'id') && Object.hasOwn(value, 'name');
};

export const isTeamValue = (value: unknown): value is TeamValue => {
	return typeof value === 'object' && value !== null && isProperShape(value);
};
